/* ==========================================================================
   Vanguarda — todo link de produto DENTRO da gaveta abre a folha.

   Antes isso dependia de cada elemento carregar data-quick-view, emitido pelo
   Liquid elemento a elemento. Bastava um ponto da area clicavel ficar de fora
   e o <a> voltava a ser um link: o cliente saia do carrinho no meio da compra.
   Foi o que acontecia nas linhas da sacola (que nunca tiveram o atributo) e de
   forma intermitente nos botoes "Choose options".

   A regra aqui e uma so, e nao depende de marcacao nenhuma: clicou num link
   para /products/ dentro de #CartDrawer, abre a folha. Vale para a foto, o
   nome, o botao e qualquer coisa que venha a ser acrescentada depois.

   Roda na fase de CAPTURA para decidir antes do handler de [data-quick-view]
   do vg-quick-add.js, senao os dois abririam a mesma folha em sequencia.

   Nao toca em nada dentro de #QuickAdd: a propria folha tem os seus botoes e
   eles continuam sendo tratados pelo vg-quick-add.js.

   Tambem pre-carrega as fotos das cores no momento em que a folha abre. A
   folha se redesenha inteira a cada troca de opcao, o que recria o <img> do
   zero e obriga o navegador a buscar a foto na rede — cerca de um segundo de
   espaco vazio a cada clique numa cor. Buscando as fotos quando a folha abre,
   a troca passa a vir do cache e e instantanea. O custo e algumas imagens
   pequenas (200px) por produto aberto, e so de quem abriu a folha.

   Degrada honestamente: se este arquivo nao carregar, ou se VGQuickAdd nao
   existir, cada <a href> volta a ser um link normal para o produto; se o
   pre-carregamento falhar, a folha volta a buscar na hora, como antes.
   ========================================================================== */
(function () {
  'use strict';

  function handleFromHref(href) {
    if (!href) return null;
    try {
      var path = new URL(href, window.location.origin).pathname;
      var m = path.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (err) {
      return null;
    }
  }

  /* Mesma transformacao de URL que o vg-quick-add.js usa para montar o <img>.
     Tem de ser identica, senao o pre-carregamento guarda um endereco e a folha
     pede outro — e o cache nao serve para nada. */
  function sized(url, w) {
    if (!url) return '';
    return url.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_' + w + 'x$1$2');
  }

  var preloaded = {};

  function preload(handle) {
    if (!handle || preloaded[handle]) return;
    preloaded[handle] = true;

    window.VGQA = window.VGQA || {};
    window.VGQA.products = window.VGQA.products || {};

    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        /* Guardado para o vg-quick-add-swatch.js escolher a foto da cor sem
           precisar de uma segunda busca. */
        window.VGQA.products[handle] = p;
        var seen = {};
        for (var i = 0; i < p.variants.length; i++) {
          var fi = p.variants[i].featured_image;
          var src = fi && fi.src;
          /* Varias variantes dividem a mesma foto (todos os tamanhos de uma
             cor), entao sem isto um produto com 40 variantes pediria 40 vezes
             as mesmas 4 imagens. */
          if (!src || seen[src]) continue;
          seen[src] = 1;
          var img = new Image();
          img.decoding = 'async';
          img.src = sized(src, 200);
        }
      })
      .catch(function () {});
  }

  document.addEventListener(
    'click',
    function (e) {
      /* Cliques modificados continuam pertencendo ao navegador. */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      if (!e.target || !e.target.closest) return;

      var link = e.target.closest('a[href]');
      if (!link) return;

      /* Só dentro da gaveta do carrinho. */
      if (!link.closest('#CartDrawer')) return;

      /* A folha cuida de si mesma. */
      if (link.closest('#QuickAdd')) return;

      var handle = handleFromHref(link.getAttribute('href'));
      if (!handle) return;

      if (!window.VGQuickAdd || typeof window.VGQuickAdd.open !== 'function') return;

      window.VGQA = window.VGQA || {};
      window.VGQA.current = handle;
      preload(handle);

      if (window.VGQuickAdd.open(handle, link)) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );
})();
